import {AbstractEntity, AbstractEntityData} from './AbstractEntity';

const uuidv4 = require('uuid/v4');

export interface CatalogPageEntityData extends AbstractEntityData {
  img: string;
}

export class CatalogPageEntity extends AbstractEntity<CatalogPageEntityData> {
  readonly id: string;

  constructor(data: CatalogPageEntityData) {
    super(data);

    this.id = uuidv4();
  }

  get img() {
    return this.data.img;
  }
}
